<template lang="html">
    <DashboardTemplate>
      <div v-if="isLoading"><Loader /></div>
      <div class="col pt-3 fade-in">
        <div class="row p-3">
          <div class="col-md-12">
            <div class="row">
              <div class="col">
                <h1><i class="bi bi-braces-asterisk"></i> CMS Widgets</h1>
              </div>
              <div class="col-12 bg-white mb-3 pt-3 mt-2 rounded-5 shadow-sm">
                <div class="row justify-content-end">
                  <div class="col-auto">
                    <label for="inputPassword2" class="visually-hidden">Search</label>
                    <input
                      type="text"
                      class="form-control rounded-5"
                      placeholder="Search"
                      v-model="searchCms"
                      v-on:keyup.enter="searchClick()"
                    />
                  </div>
                  <div class="col-auto tooltip-wrap">
                    <button
                      type="submit"
                      class="btn btn-outline-primary mb-3 rounded-5"
                      @click="searchClick()"
                    >
                      <i class="bi bi-search"></i>
                      <span class="tooltip">Search Here</span>
                    </button>
                  </div>
                  <!-- <div class="col-auto tooltip-wrap">
                    <a href="/cms-widget" class="btn btn-outline-success me-3 rounded-5"
                      ><i class="bi bi-database-add"></i>
                      <span class="tooltip">Add New</span>
                    </a>
                  </div> -->
                </div>
              </div>
            </div>

            <div
              v-if="successMsg"
              class="card text-success text-center border-success rounded-5 mb-3"
            >
              <div class="card-body">{{ successMsg }}</div>
            </div>
            <div v-if="errorMsg" class="card text-danger text-center border-danger rounded-5 mb-3">
              <div class="card-body">
                <ul v-for="(item, index) in errorMsg" :key="index">
                  <li v-if='item.detail && item.detail.includes("already exists")'> Unable to update widget </li>
                  <li v-else>
                    {{ item.path.replace(/[\-\_\|]/g, ' ').toUpperCase() }} -
                    {{ item.msg.replace(/[\-\_\|]/g, ' ').toUpperCase() }}
                  </li>
                </ul>
              </div>
            </div>
            <div class="card shadow-sm">
              <div class="card-body">
                <div class="card-text">
                  <div class="table-responsive">
                    <table class="table table-striped table-bordered">
                      <thead>
                        <tr>
                          <th>UUID</th>
                          <th>Widget Name</th>
                          <th>Title</th>
                          <th>Edit</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-if="cmsWidgets?.total === 0">
                          <td scope="col" colspan="8" class="text-center text-primary pt-3 pb-3">
                            Not Found
                          </td>
                        </tr>
                        <tr v-else v-for="(item, index) in cmsWidgets.items" :key="index">
                          <td>{{ item.id }}</td>
                          <td>{{ item.widget_name }}</td>
                          <td>{{ item.title }}</td>
                          <td>
                          <button
                            class="btn btn-outline-primary bi bi-pencil-square rounded-5"
                            @click="goToDetails(item.id)"
                          ></button>
                        </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <div class="d-flex justify-content-center mt-4">
              <VuejsPaginateNext
                v-model="page"
                :page-count="pageCount"
                :click-handler="pageClick"
                :margin-pages="2"
                :page-range="3"
                :container-class="'pagination'"
                :page-class="'page-item'"
                :page-link-class="'page-link'"
                :prev-class="'prev-item'"
                :prev-link-class="'page-link prev-link-item'"
                :next-class="'next-item'"
                :next-link-class="'page-link next-link-item'"
                :break-view-class="'break-view'"
                :break-view-link-class="'break-view-link'"
              ></VuejsPaginateNext>
            </div>
          </div>
        </div>
      </div>
    </DashboardTemplate>
  </template>
<script>
import { useStore } from 'vuex';
import { ref, computed } from 'vue';
import CmsPageService from '@/services/CmsPageService';
import DashboardTemplate from '@/components/templates/DashboardTemplate.vue';
import VuejsPaginateNext from '@/components/partials/Paginate.vue';
import { useRouter } from 'vue-router';

const cmsPageService = new CmsPageService();

export default {
  name: 'CmsWidgets',
  components: {
    DashboardTemplate,
    VuejsPaginateNext,
  },
  setup() {
    const store = useStore();
    const router = useRouter();
    const cmsList = ref([]);
    const searchCms = ref('');
    const currentOffset = ref(0);
    const pageCount = ref(0);
    const perPage = ref(10);
    const page = ref(1);
    const SearchData = {
      searchCms,
      currentOffset,
      perPage,
    };
    store.dispatch('fetchAllCmsWidgets', SearchData).then((response) => {
      pageCount.value = Math.ceil(response.data.total / perPage.value);
    });
    const searchClick = () => {
      currentOffset.value = 0;
      const search = {
        searchCms,
        currentOffset,
        perPage,
      };
      store.dispatch('fetchAllCmsWidgets', search).then((response) => {
        pageCount.value = Math.ceil(response.data.total / perPage.value);
      });
    };
    const pageClick = (pageNum) => {
      currentOffset.value = perPage.value * (pageNum - 1);
      const Data = {
        searchCms,
        currentOffset,
        perPage,
      };
      store.dispatch('fetchAllCmsWidgets', Data).then((response) => {
        pageCount.value = Math.ceil(response.data.total / perPage.value);
      });
    };

    const cmsWidgets = computed(() => store.getters.getCmsWidgets);

    const cmsListDetailsById = computed(() => store.getters.getCmslistdetailsById);

    const goToDetails = (id) => {
      store.dispatch('fetchCmsWidgetdetailsById', id).then(() => {
        router.push({ name: 'CmsWidgetDetails', params: { id } });
      });
    };

    return {
      cmsList,
      goToDetails,
      cmsWidgets,
      cmsListDetailsById,
      searchClick,
      searchCms,
      pageClick,
      page,
      pageCount,
    };
  },
};
</script>
